export const getArcDataInnerRadius = (layer: any) => {
  if (!layer.arcData) {
    console.warn('ArcData: Inner Radius (Ratio) Error');
  }

  return Number(layer.arcData.innerRadius.toFixed(4));
};
